/**
 * Locale-aware formatting (numbers/dates/currency). Use for tables/charts;
 * wrap bare digits in `.admin-ltr` when mixing with Arabic paragraphs.
 */
export function getAdminFormatters(locale) {
  const isAr = locale === "ar"
  const tag = isAr ? "ar-QA" : "en-GB"

  return {
    formatDateTime(value, options) {
      const d = value instanceof Date ? value : new Date(value)
      if (Number.isNaN(d.getTime())) return ""
      return new Intl.DateTimeFormat(tag, {
        dateStyle: "short",
        timeStyle: "short",
        ...options
      }).format(d)
    },
    formatDate(value, options) {
      const d = value instanceof Date ? value : new Date(value)
      if (Number.isNaN(d.getTime())) return ""
      return new Intl.DateTimeFormat(tag, {
        dateStyle: "medium",
        ...options
      }).format(d)
    },
    formatNumber(value, options) {
      return new Intl.NumberFormat(tag, options).format(Number(value) || 0)
    },
    formatCurrency(value, currency = "QAR") {
      return new Intl.NumberFormat(tag, {
        style: "currency",
        currency
      }).format(Number(value) || 0)
    }
  }
}
